import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import SelectClient from "./SelectClient";
import { useSelector } from "react-redux";
import ProfileMenu from "./ProfileMenu";
import Notification from "./Notification/index";

const RightPanel = (props) => {
  const { loading } = props;
  // state.clients.selectedClient (from getUserClients, the dropdown's own data source)
  // doesn't carry a usable clientLogoPath - state.pages.homePageData.client (from
  // getHomePageData) is the source that actually had a working logo, matching what
  // TmeHome.js used before this moved into the nav bar.
  const clientLogoPath = useSelector(
    (state) => state.pages.homePageData?.client?.clientLogoPath
  );
  const [logoFailed, setLogoFailed] = useState(false);

  useEffect(() => {
    setLogoFailed(false);
  }, [clientLogoPath]);

  const showLogo = clientLogoPath && !logoFailed;

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "100%" }}>
      {showLogo && (
        <img
          src={clientLogoPath}
          alt="Client Logo"
          onError={() => setLogoFailed(true)}
          style={{
            height: "24px",
            maxWidth: "120px",
            objectFit: "contain",
            marginRight: "20px",
          }}
        />
      )}
      <SelectClient loading={loading} />
      <Notification />
      <ProfileMenu />
    </div>
  );
};

export default RightPanel;
